import { z } from 'zod';

export const estimationSchema = z.object({
  id: z.number().int().positive(),
  label: z.string(),
  highEffort: z.number().int().optional(),
  lowEffort: z.number().int().optional(),
  priority: z.string(),
});

export const estimationDisplaySchema = z.object({
  id: z.number().int().positive(),
  label: z.string(),
  highEffort: z.number().int().optional(),
  lowEffort: z.number().int().optional(),
});

export type EstimationDTO = z.infer<typeof estimationSchema>;
export type EstimationDisplayDTO = z.infer<typeof estimationDisplaySchema>;
